var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_74_11614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H40C45.5228 1 50 5.47715 50 11V39C50 44.5228 45.5228 49 40 49H12C6.47715 49 2 44.5228 2 39V11Z",
    fill: "url(#paint0_linear_74_11614)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 34L18 17M18 26H25.4C25.9601 26 26.2401 26 26.454 25.891C26.6422 25.7951 26.7951 25.6422 26.891 25.454C27 25.2401 27 24.9601 27 24.4V17.6C27 17.0399 27 16.7599 26.891 16.546C26.7951 16.3578 26.6422 16.2049 26.454 16.109C26.2401 16 25.9601 16 25.4 16H19.6C19.0399 16 18.7599 16 18.546 16.109C18.3578 16.2049 18.2049 16.3578 18.109 16.546C18 16.7599 18 17.0399 18 17.6V26ZM27 18H33.4C33.9601 18 34.2401 18 34.454 18.109C34.6422 18.2049 34.7951 18.3578 34.891 18.546C35 18.7599 35 19.0399 35 19.6V26.4C35 26.9601 35 27.2401 34.891 27.454C34.7951 27.6422 34.6422 27.7951 34.454 27.891C34.2401 28 33.9601 28 33.4 28H28.6C28.0399 28 27.7599 28 27.546 27.891C27.3578 27.7951 27.2049 27.6422 27.109 27.454C27 27.2401 27 26.9601 27 26.4V18Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_74_11614",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_11614"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_11614",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_11614",
    x1: 50,
    y1: 1,
    x2: -3.14295,
    y2: 19.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6045CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#606CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#4B8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32D3A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon3);
export default __webpack_public_path__ + "static/media/services_icon_3.5c42126adfd1bbccd129cd1c56098653.svg";
export { ForwardRef as ReactComponent };